// client/src/services/developersApi.js
// Settings → Developers (Roadmap Phase 6): API keys, webhook endpoints,
// deliveries. Server: routes/developerRoutes.js at /api/developers/:tenant
// (owners / admins). The public API description: GET /api/v1/openapi.json.

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

async function request(method, url, body) {
  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${res.status} ${res.statusText}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

const base = (tenantId) => `/api/developers/${Number(tenantId)}`;

export function errorText(err, fallback) {
  return err?.response?.data?.message || err?.response?.data?.error || fallback;
}

export const apiBaseUrl = () => `${BASE_URL || window.location.origin}/api/v1`;
export const getDevelopersOverview = (tenantId) => request('GET', `${base(tenantId)}/overview`);
export const createApiKey = (tenantId, body) => request('POST', `${base(tenantId)}/keys`, body);
export const revokeApiKey = (tenantId, id) => request('DELETE', `${base(tenantId)}/keys/${Number(id)}`);
export const createWebhook = (tenantId, body) => request('POST', `${base(tenantId)}/webhooks`, body);
export const updateWebhook = (tenantId, id, body) => request('PUT', `${base(tenantId)}/webhooks/${Number(id)}`, body);
export const deleteWebhook = (tenantId, id) => request('DELETE', `${base(tenantId)}/webhooks/${Number(id)}`);
export const rotateWebhookSecret = (tenantId, id) => request('POST', `${base(tenantId)}/webhooks/${Number(id)}/secret`);
export const testWebhook = (tenantId, id) => request('POST', `${base(tenantId)}/webhooks/${Number(id)}/test`);
export const listDeliveries = (tenantId, { endpointId, status } = {}) => {
  const qs = new URLSearchParams();
  if (endpointId) qs.set('endpointId', endpointId);
  if (status) qs.set('status', status);
  const s = qs.toString();
  return request('GET', `${base(tenantId)}/deliveries${s ? `?${s}` : ''}`);
};
export const redeliver = (tenantId, id) => request('POST', `${base(tenantId)}/deliveries/${Number(id)}/redeliver`);
export const getOpenApi = () => request('GET', '/api/v1/openapi.json');
